import React from "react";

export const numberFormattingContext = React.createContext({
    fractionDigits: 2
});

interface Props {
    children: React.ReactNode;
    fractionDigits: number;
}

export const NumberFormattingProvider = ({ children, fractionDigits = 2 }: Props) => (
    <numberFormattingContext.Provider value={{ fractionDigits }}>{children}</numberFormattingContext.Provider>
);
